var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_product-info-content"},[(_vm.showAdditionalMessageInfo)?_c('AdditionalMessageInfo'):_vm._e(),(_vm.showPremiumIdInfo)?_c('PremiumIdInfo'):_vm._e(),(_vm.showOaChatPackageInfo)?_c('OaChatPackageInfo'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }